import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props'

export default function NotFound() {
  return (
    <div className="flex justify-center">
      <h1 className="p-1">404 - Page Not Found</h1>
    </div>
  )
}

export const getServerSideProps = getBaseServerSideProps([])
